import { render, staticRenderFns } from "./task_statistics.vue?vue&type=template&id=11fab8dc&scoped=true"
import script from "./task_statistics.vue?vue&type=script&lang=js"
export * from "./task_statistics.vue?vue&type=script&lang=js"
import style0 from "./task_statistics.vue?vue&type=style&index=0&id=11fab8dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fab8dc",
  null
  
)

export default component.exports